import { useEffect, useMemo, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import Table from '../../../core/common/dataTable/index'
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod';
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl';
import Loading from '../../../core/common/custom-loading/Loading';
import SearchSelect from '../../../core/common/search-select/searchSelect';
import CommonSelect2 from '../../../core/common/commonSelect2';


const StaffList = () => {
    const [loading, setLoading] = useState(false);
    const routes = all_routes;
    const [getTanant, setGetTanant] = useState<any>([])
    console.log("state tanant", getTanant)
    const organizationId = localStorage.getItem("organization_id")
    const getAllTanant = async () => {
        const payload = {
            organization_id: organizationId,
            dashboard: "true"
        }
        try {
            setLoading(true)
            const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.GET_ALL_PROPERTY_TANANT, payload)
            if (response?.success == true) {
                const result = response?.data
                // console.log("tatant 222 data vvvvvvvv", response)
                setGetTanant(result)
            }

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        getAllTanant();
    }, [])
    const columns = [
        {
            title: "Tenant Id",
            dataIndex: "tenant_id",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.tenant_id || "").localeCompare(b.tenant_id || ""),
        },
        {
            title: "Full Name",
            dataIndex: "full_name",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.full_name || "").localeCompare(b.full_name || ""),
        },
        {
            title: "Email Id",
            dataIndex: "email_id",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.email_id || "").localeCompare(b.email_id || ""),
        },
        {
            title: "Occupation",
            dataIndex: "occupation",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.occupation || "").localeCompare(b.occupation || ""),
        },

        {
            title: "Contact Number",
            dataIndex: "full_number", // Optional: not actually used here
            render: (_: any, record: any) => {
                const countryCode = record.country_code ?? "";
                const msisdn = record.msisdn ?? "";
                const display = countryCode && msisdn ? `${countryCode}- ${msisdn}` : "-";
                return <p className="text-capitalize">+{display}</p>;
            },
            sorter: (a: any, b: any) => {
                const fullA = `${a.country_code ?? ""}${a.msisdn ?? ""}`;
                const fullB = `${b.country_code ?? ""}${b.msisdn ?? ""}`;
                return fullA.localeCompare(fullB);
            },
        },

        {
            title: "Is B2B User",
            dataIndex: "is_b2b_user",
            render: (text: any, record: any) => {
                let displayText = "-";

                if (text === 1 || text === "1") {
                    displayText = "Yes";
                } else if (text === 0 || text === "0") {
                    displayText = "No";
                }

                return <p className="text-capitalize">{displayText}</p>;
            },
            sorter: (a: any, b: any) => {
                const valA = Number(a.is_b2b_user ?? -1);
                const valB = Number(b.is_b2b_user ?? -1);
                return valA - valB;
            },
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            render: (text: string) => {
                if (!text) return <p>-</p>;

                const date = new Date(text);
                const formattedDate = date.toLocaleDateString("en-GB"); // Format: DD/MM/YYYY

                return <p>{formattedDate}</p>;
            },
            sorter: (a: any, b: any) => {
                return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string, record: any) => {
                const status = text?.toLowerCase();

                let textColor = "inherit";
                let backgroundColor = "transparent";

                switch (status) {
                    case "active":
                        textColor = "green";
                        backgroundColor = "#e6f4ea"; // light green bg
                        break;
                    case "invited":
                        textColor = "red";
                        backgroundColor = "#fdecea"; // light red bg
                        break;
                    case "available":
                        textColor = "goldenrod";
                        backgroundColor = "#fff8e1"; // light yellow bg
                        break;
                }

                const formatedText = text ? text.charAt(0).toUpperCase()+ text.slice(1).toLowerCase()  : "-"

                return (
                    <span
                        // className="text-capitalize"
                        style={{
                            color: textColor,
                            backgroundColor,
                            padding: "4px 8px",
                            borderRadius: "6px",
                            display: "inline-block",
                            minWidth: "80px",
                            textAlign: "center",
                            textTransform:"capitalize"
                        }}
                    >
                        {formatedText}
                    </span>
                );
            },
            sorter: (a: any, b: any) => (a.status || "").localeCompare(b.status || ""),
        }




    ];



    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Tenant List  </h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Dashboard
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Tenant List
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
                            {/* <Link to={routes.AllOrganizations}>
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                >
                                    <i className="ti ti-arrow-left me-2" />
                                    Back
                                </button>
                            </Link> */}
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* <div className="col-md-12 mb-3 bg-white border p-3 shadow-sm rounded-3">
                        <label className='pb-2 fw-medium fs-15 d-block'>Select Organization:</label>
                        <CommonSelect2 className='d-inline ' options={options_organization} name='organization' defaultValue={orgId} onChange={(e: any) => setOrgId(e?.value)} styles={{ maxWidth: "500px" }} />
                        <button className='btn btn-primary px-3 ms-2' onClick={searchProperties}> <i className="bi bi-search me-sm-1"></i><span className='d-none d-sm-inline'>Search</span></button>
                    </div> */}

                    {/* Performance Indicator list */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Tenant List</h5>
                        </div>
                        <div className="card-body p-0">
                            {loading
                                ? <Loading />
                                : <Table dataSource={getTanant} rowKeyId={"Staff_id"} columns={columns} Selection={false} />
                            }
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
               <p className="mb-0">© {new Date().getFullYear()} Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    )
}

export default StaffList;